export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10234.b65e677d.jpg";